import { render, staticRenderFns } from "./OnTestTable.vue?vue&type=template&id=1c251e2a&scoped=true"
import script from "./OnTestTable.vue?vue&type=script&lang=ts"
export * from "./OnTestTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c251e2a",
  null
  
)

export default component.exports